// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jwU2Twime26MzAnGko5P {
  border-left: 1px solid #ddd;
  height: 100%;
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/CellPanel/index.module.less"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;AACF","sourcesContent":[".rightPanel {\n  border-left: 1px solid #ddd;\n  height: 100%;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightPanel": `jwU2Twime26MzAnGko5P`
};
export default ___CSS_LOADER_EXPORT___;
